import { Button, List, Menu, Message } from "semantic-ui-react";

import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { useInstantSearch } from "react-instantsearch";
import { useStats } from "react-instantsearch-core";

import { firebase } from "astrid-firebase";

import Flex from "../../../../../components/Flex/Flex";
import algoliaFiltersFromUiState from "../../../../algolia/utils/algoliaFiltersFromUiState";

const calculateDuration = firebase.functions().httpsCallable("algolia-calculateDuration");

export default function ProductionsDurationCalculation() {
	const { t } = useTranslation();
	const { indexUiState } = useInstantSearch();
	const [isCalculatingDuration, setIsCalculatingDuration] = useState(false);
	const [duration, setDuration] = useState();
	const { nbHits } = useStats();

	const [active, setActive] = useState(false);

	return (
		<Menu fluid vertical text>
			<Menu.Item active={active} onClick={() => setActive((active) => !active)}>
				<Flex gap={5}>{t("calculateDuration", "Calculate duration")}</Flex>
			</Menu.Item>

			<Menu.Menu
				style={{
					display: !active && "none",
					paddingLeft: 15,
					borderLeft: "1px solid rgba(0, 0, 0, 0.08)",
				}}
			>
				{!isCalculatingDuration && duration && (
					<List style={{ paddingTop: 1 }}>
						<List.Item style={{ userSelect: "auto" }}>
							<List.Header>{t("totalDuration", "Total duration")}</List.Header>
							<List.Content>{duration?.actual}</List.Content>
						</List.Item>

						<List.Item style={{ userSelect: "auto" }}>
							<List.Header>{t("totalEstimatedDuration", "Total estimated duration")}</List.Header>
							<List.Content>{duration?.estimated}</List.Content>
						</List.Item>

						<List.Item style={{ userSelect: "auto" }}>
							<List.Header>{t("numberOfProductions", "Number of productions")}</List.Header>
							<List.Content>{duration?.numberOfProductions}</List.Content>
						</List.Item>
					</List>
				)}

				{nbHits > 10000 && (
					<Message
						info
						size="tiny"
						content={t(
							"toManyHitsToCalcualteDuration",
							"You can not calculate hits for more than 10 000 productions",
						)}
					/>
				)}

				<Button
					size="tiny"
					loading={isCalculatingDuration}
					disabled={isCalculatingDuration || nbHits > 10000}
					onClick={() => {
						setDuration(undefined);
						setIsCalculatingDuration(true);

						const { query, filters } = algoliaFiltersFromUiState(indexUiState);

						calculateDuration({ query, filters })
							.then((data) => {
								setIsCalculatingDuration(false);
								setDuration(data.data);
							})
							.catch((error) => {
								console.error(error);
							});
					}}
				>
					{t("calculate", "Calculate")}
				</Button>
			</Menu.Menu>
		</Menu>
	);
}
